import ForgotPassword from "@/app/forgot-password/page";
import { Providers } from "@/app/providers";
import ResetPassword from "@/app/reset-password/page";
import ReactDOM from "react-dom/client";
import { Navigate } from "react-router";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./index.css";
import Login from "./login/page";
import AddMediaRate from "./media-rates/new/page";
import MediaRates from "./media-rates/page";
import EditMediaRate from "./media-rates/[id]/page";
import SignUp from "./sign-up/page";
import AddSponsorship from "./sponsorships/new/page";
import Sponsorships from "./sponsorships/page";
import EditSponsorship from "./sponsorships/[id]/page";
import Users from "./users/page";
import EditUsers from "./users/[id]/page";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <BrowserRouter>
    <Providers>
      <Routes>
        <Route path="/sponsorships" Component={Sponsorships} />
        <Route path="/sponsorships/new" Component={AddSponsorship} />
        <Route path="/sponsorships/:id" Component={EditSponsorship} />
        <Route path="/media-rates" Component={MediaRates} />
        <Route path="/media-rates/new" Component={AddMediaRate} />
        <Route path="/media-rates/:id" Component={EditMediaRate} />
        <Route path="/users" Component={Users} />
        <Route path="/users/:id" Component={EditUsers} />
        <Route path="/login" Component={Login} />
        <Route path="/sign-up" Component={SignUp} />
        <Route path="/forgot-password" Component={ForgotPassword} />
        <Route path="/reset-password" Component={ResetPassword} />
        <Route path="*" element={<Navigate to="/sponsorships" replace />} />
      </Routes>
    </Providers>
  </BrowserRouter>
);
